<div mat-dialog-title class="dialog-info horizontal-padding m-0">
    <label class="dialogTitle">
        {{'REQUIRED_FIELDS_ERROR' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none dialogCross" [mat-dialog-close]></button>
</div>

<mat-dialog-content class="horizontal-padding d-flex">
    <!-- Left section with status icon -->
    <div>
        <mat-icon class="icon-class cancel">cancel</mat-icon>
    </div>
    
    <!-- Right section with content -->
    <div class="horizontal-padding">
        <div>
            <p>{{ 'REQUIRED_FIELDS_ERROR_MESSAGE' | translate }}</p>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions-style">
    <button class="openCloseBtn" mat-raised-button color="primary" mat-dialog-close>{{'OK' | translate}}</button>
</mat-dialog-actions>